export const API_ENDPOINTS = {

    AUTH: {
        GET_ACCOUNT_OWNER: "account_owner",
        GET_LEAD_OWNER: "lead_owner",
        GET_COUNTRY_CURRENCY: "country_currency_list",
        FARMER_LIST: "farmers_list",
        HUNTER_LIST: "hunters_list",
        REFERRER_LIST: "referrers_list"
    },

    GET_FILES: {
        EXISTING_FILES: "list-files",
        PREVIEW_FILE: "preview-file",
        UPLOAD_FILE: "by-doc-type",
        SEND_TO_COMPLIANCE: "send-compliance-email"
    },

    GET_ACCOUNTS:{
        ASSOCIATED_INFO: "acc-associated-info",
        CONTACTS: "acc_det_contact",
        DETAILS: "acc_details_tbl",
        STATISTICS: "acc_det_statistics",
        ALL_INVENTORY: "account-inventory-table-all",
        YOURS_INVENTORY: "account-inventory-table-yours",
        INCOMING_INVENTORY: "inventory/incoming"
    },
    UPDATE_ACCOUNTS: {
        DETAILS: "update_account_details",
        INFO_GATHERING: "update_info_gathering",
        ADD_CONTACTS: "acc_det_contact_add",
        UPDATE_CONTACTS: "acc_det_contact_update"
    },

    GET_LEADS: {
        JOURNEY: "lead_journey_tbl",
        INFO_GATHERING: "lead_journey_info_gathering",
        CARD: "lead_journey_card",
        ALL_INVENTORY: "lead-inventory-table-all",
        SHARK_TANK: "shark-tank",
        YOURS_INVENTORY: "lead-inventory-table-yours",
        ADDITIONAL_INFO:"get-additional-info"
    },

    UPDATE_LEADS:{
        LEAD_OWNER:"change-lead-owner",
        ADD_LEAD:"add_lead",
        REJECT_LEAD:"leadReject",
        LEAD_JOURNEY: "update_lead_journey",
        INFO_GATHERING:"info-gathering",
        ADDITIONAL_INFO: "additional-information"
    },

    GET_OPPORTUNITIES: {
        FUZZY: {
            SEARCH: "api/search",
            LEADS: "api/leads",
            CONTACTS: "api/contacts"
        },
        INFO_GATHERING: "opp",
        INVENTORY: "opportunity-inventory",
        JOURNEY: "opportunity-journey"
    },

    GET_REMINDER: {
        LAST_REMINDER: "reminders/last",
        ALL_REMINDERS: "reminders/all",
        REMINDER_DETAILS: "sidebar_info"
    },

    GET_INTERACTIONS:{
        LAST_INTERACTIONS: "interactions/last",
        ALL_INTERACTIONS: "interactions/all"
    },

    ADD_REMINDER: "add_reminder",
    ADD_INTERACTION: "add_interaction"
}
